import Common from '../../../Common';
import Users from "./group/Users";

const Group = class extends Common {
	users: InstanceType<typeof Users>

	constructor(headers: ApiHeaders) {
		super(headers)

		this.users = new Users(headers)
	}

	browse = (companyId: id): CustomResponse<{groups: AclGroup[]}> =>
		this.get(`/company/${companyId}/acl/groups`)
}

export default Group;
